module.exports = __webpack_public_path__ + "img/slider_5.38e3fb66.jpg";